<template lang="pug">
.IndustryLibraryList
  .list_item(v-for="(item, i) in listNew", :key="i")
    .list_item_content
      .logo_title
        BaseAvatar(:imgUrl="item.imgUrl", :title="item.eventName")
        router-link.title(
          :to="{ name: 'crisisDetails', query: { id: item.id } }",
          target="_blank"
        ) {{ item.eventName }}
      .paragraph(style="-webkit-box-orient: vertical") {{ item.introduction }}
      .time_tags
        .time {{ item.startTime }}
        .tags
          .tag.blue {{ item.priBrand }}
          .tag.green(
            v-for="(cirsis, index) in item.priCrisisTags",
            :key="index"
          ) {{ cirsis }}
  NoData(v-if="listNew.length === 0")
</template>

<script>
import moment from 'moment'
import NoData from '../components/NoData.vue'
import BaseAvatar from '@index/components/BaseAvatar.vue'
export default {
  components: { NoData, BaseAvatar },
  props: {
    list: Array
  },
  data () {
    return {}
  },
  computed: {
    listNew () {
      return this.list.map(t => {
        return {
          ...t,
          startTime: t.startTime ? moment(t.startTime).format('YYYY-MM-DD') : '--'
        }
      })
    }
  },
  watch: {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.IndustryLibraryList {
  margin-top: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  .list_item {
    width: 33.33%;
    padding-right: 20px;
    padding-bottom: 20px;
    &:nth-child(3n) {
      padding-right: 0;
    }
    .list_item_content {
      border-radius: 4px;
      background-color: #ffffff;
      padding: 24px 20px;
      .logo_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
          width: 46px;
          height: 46px;
          border-radius: 4px;
          border: solid 1px #f4f4f4;
        }
        .title {
          margin-left: 24px;
          flex: 1;
          width: 0;
          font-size: 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover {
            color: #3989cb;
          }
        }
      }
      .paragraph {
        margin-top: 30px;
        color: #666666;
        line-height: 24px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .time_tags {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .time {
          font-size: 12px;
          color: #444444;
        }
        .tags {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tag {
            height: 24px;
            padding: 0 10px;
            line-height: 24px;
            border-radius: 2px;
            text-align: center;
            &.blue {
              color: #025fea;
              background-color: #e5edfa;
            }
            &.green {
              margin-left: 14px;
              color: #50b357;
              background-color: #edf7ee;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/IndustryEvent/IndustryEventList.vue